import React from 'react';
import { SubPageShell } from '../App';
import { smmPlatforms, smmDescription } from '../mock';
import { Instagram, Youtube, Camera, TrendingUp } from 'lucide-react';
import { TickList, ContactPromptCard } from '../components/SharedUI';

function PlatformIcon({ network, size = 22 }) {
  if (network === 'instagram') return <Instagram size={size} strokeWidth={1.6} />;
  if (network === 'youtube')   return <Youtube size={size} strokeWidth={1.6} />;
  if (network === 'snapchat')  return <Camera size={size} strokeWidth={1.6} />;
  return <TrendingUp size={size} strokeWidth={1.6} />;
}

export default function SMMPage() {
  return (
    <SubPageShell kicker="06 — Full SMM" title={<>Social Media Management.</>}>
      <div className="section" style={{ paddingTop: 40 }}>
        <div style={{ maxWidth: 720, marginBottom: 36 }}>
          {smmDescription.map((line, i) => (
            <p
              key={i}
              style={{
                color: i === 0 ? '#f5f5f5' : 'rgba(245,245,245,0.65)',
                fontSize: i === 0 ? 18 : 15,
                lineHeight: 1.7,
                margin: '0 0 6px 0',
              }}
            >
              {line}
            </p>
          ))}
        </div>

        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(320px, 1fr))', gap: 20 }}>
          {smmPlatforms.map((p) => (
            <div key={p.id} className="glass-card" style={{ padding: 28, display: 'flex', flexDirection: 'column', gap: 18 }}>
              <div style={{ display: 'flex', alignItems: 'center', gap: 14 }}>
                <div className="smm-logo">
                  <PlatformIcon network={p.network} />
                </div>
                <div>
                  <div className="mono" style={{ fontSize: 10, letterSpacing: '0.3em', color: 'rgba(245,245,245,0.45)', textTransform: 'uppercase' }}>
                    Platform
                  </div>
                  <div style={{ fontFamily: 'Space Grotesk, sans-serif', fontSize: 22, fontWeight: 500, marginTop: 2 }}>
                    {p.platform}
                  </div>
                </div>
              </div>
              <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
                {p.services.map((s) => (
                  <div
                    key={s.name}
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'space-between',
                      padding: '12px 14px',
                      border: '1px solid rgba(245,245,245,0.08)',
                      borderRadius: 10,
                      background: 'rgba(10,10,10,0.4)',
                    }}
                  >
                    <span style={{ fontFamily: 'Space Grotesk, sans-serif', fontSize: 16, color: '#f5f5f5' }}>{s.name}</span>
                    <span className="mono" style={{ fontSize: 10, letterSpacing: '0.25em', color: 'rgba(245,245,245,0.5)', textTransform: 'uppercase' }}>
                      DM for price
                    </span>
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>

        <ContactPromptCard message="Want a custom growth bundle? Tell me your goals — I will build a quote." />
      </div>
    </SubPageShell>
  );
}
